var map = {
	"./ametista.png": "ea18",
	"./bronze.png": "223a",
	"./diamante-i.png": "92b7",
	"./diamante-ii.png": "35e3",
	"./diamante-iii.png": "cb28",
	"./diamante.png": "50dc",
	"./esmeralda.png": "2321",
	"./index.html": "2a19",
	"./ouro.png": "f664",
	"./prata.png": "a3ea",
	"./rubi.png": "2c17",
	"./safira.png": "8da2",
	"./start.png": "b85a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ee0";